let clerkTokenGetter = null;
let clerkAuthState = {
  isLoaded: false,
  isSignedIn: false,
};

const sleep = (delayMs) => new Promise((resolve) => setTimeout(resolve, delayMs));

const getWindowClerkToken = async (tokenOptions) => {
  if (typeof window === 'undefined') {
    return null;
  }

  const session = window.Clerk?.session;

  if (!session?.getToken) {
    return null;
  }

  return session.getToken(tokenOptions);
};

export const setClerkTokenProvider = (getter, authState = {}) => {
  clerkTokenGetter = typeof getter === 'function' ? getter : null;
  clerkAuthState = {
    isLoaded: Boolean(authState.isLoaded),
    isSignedIn: Boolean(authState.isSignedIn),
  };
};

export const clearClerkTokenProvider = () => {
  clerkTokenGetter = null;
  clerkAuthState = {
    isLoaded: false,
    isSignedIn: false,
  };
};

export const getClerkAuthState = () => clerkAuthState;

export const waitForClerkToken = async (options = {}) => {
  const {
    // On subdomains (chat.tuliza.org), Clerk's useAuth() may report isSignedIn=false
    // even though window.Clerk.session is active (subdomain identity crisis).
    // Keep minimum 3 retries so we have time to fall through to the window.Clerk fallback.
    retries = clerkAuthState.isSignedIn ? 10 : clerkAuthState.isLoaded ? 3 : 5,
    delayMs = 250,
    ...tokenOptions
  } = options;

  for (let attempt = 0; attempt <= retries; attempt += 1) {
    // 1. Try the hook-based getter registered by ClerkTokenBridge (useAuth().getToken)
    if (typeof clerkTokenGetter === 'function') {
      try {
        const token = await clerkTokenGetter(tokenOptions);
        if (token) return token;
      } catch (error) {
        // Ignore transient Clerk session timing issues during redirect completion.
      }
    }

    // 2. ALWAYS try window.Clerk.session as a secondary fallback every attempt.
    //    This handles the subdomain case: useAuth() says isSignedIn=false on
    //    chat.tuliza.org, but window.Clerk.session still holds a valid session.
    try {
      const windowToken = await getWindowClerkToken(tokenOptions);
      if (windowToken) return windowToken;
    } catch (error) {
      // ignore
    }

    if (attempt === retries) break;

    // Only give up early if Clerk is loaded, says not signed-in, AND there is no
    // window.Clerk session to fall back to.
    if (clerkAuthState.isLoaded && !clerkAuthState.isSignedIn) {
      const hasWindowSession =
        typeof window !== 'undefined' && !!window.Clerk?.session;
      if (!hasWindowSession) break;
    }

    await sleep(delayMs);
  }

  return null;
};